import { MAX_ATTACHMENT_BYTES, type AttachmentDto } from '@tms/shared';
import { api } from '../../lib/api-client';

/** True for the files the attachment endpoint accepts (checked again server-side). */
export const isSupportedImage = (file: File): boolean => file.type.startsWith('image/');

export const isWithinSizeLimit = (file: File): boolean => file.size <= MAX_ATTACHMENT_BYTES;

export const uploadAttachment = (projectCode: string, file: File): Promise<AttachmentDto> =>
  api.upload<AttachmentDto>(`/projects/${projectCode}/attachments`, file, {
    fileName: file.name,
  });

/** Pulls image files out of a paste or drop event, ignoring anything else. */
export const imageFilesFrom = (list: FileList | null | undefined): File[] =>
  list ? [...list].filter(isSupportedImage) : [];
